export default "__VITE_ASSET__C3XApal7__"